// extracted by mini-css-extract-plugin
module.exports = {"root":"Puds2","error":"_30_qY"};